import React from 'react';
import {
  NavItem,
  NavLink,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem
} from 'shards-react';

import { NavLink as RouteNavLink, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import PropTypes from 'prop-types';

class SidebarDropDownNavItem extends React.Component {
  constructor(props) {
    super(props);
    this.item = props.item;
    this.state = {
      open: this.isItemActive(props.location.pathname),
      active: false
    };
  }

  componentDidUpdate(prevProps) {
    const { pathname } = this.props.location;
    if (prevProps.location.pathname !== pathname && this.isItemActive(pathname)) {
      this.setState({ open: true });
    }
  }

  isItemActive = (pathname) =>
    this.item.tabs.some((tab) => pathname === tab.to || pathname.startsWith(`${tab.to}/`));

  toggle = () => {
    this.setState((prevState) => ({
      open: !prevState.open
    }));
  };

  handleTitleClick = () => {
    this.setState({ open: true });
  };

  render() {
    const toggleBackground = this.state.open ? 'rgba(0, 0, 0, 0.05)' : 'transparent';
    const toggleHover = this.state.open ? '0.1' : '0.05';

    return (
      <Dropdown className="FlexColumn" group open={this.state.open} toggle={this.toggle}>
        <div className="FlexRow" style={{ cursor: 'pointer' }}>
          <div className="Flex3">
            <NavItem active={this.state.active} style={{ cursor: 'pointer' }}>
              <NavLink tag={RouteNavLink} to={this.item.to} onClick={this.handleTitleClick}>
                {this.item.htmlBefore && (
                  <div
                    className="d-inline-block item-icon-wrapper"
                    dangerouslySetInnerHTML={{ __html: this.item.htmlBefore }}
                  />
                )}
                {this.item.name && <span>{this.item.name}</span>}
              </NavLink>
            </NavItem>
          </div>
          <Toggle backgroundcolor={toggleBackground} hovercolor={toggleHover} theme="none">
            <em className="material-icons" style={{ fontSize: 25 }}>
              {this.state.open ? 'expand_less' : 'expand_more'}
            </em>
          </Toggle>
        </div>
        <div className="FlexColumn">
          <DropdownMenu>
            {this.item.tabs.map((tab, i) => {
              return (
                <DropdownItem key={i} tag={RouteNavLink} to={tab.to} toggle={false}>
                  {tab.name && <span>{tab.name}</span>}
                </DropdownItem>
              );
            })}
          </DropdownMenu>
        </div>
      </Dropdown>
    );
  }
}

const Toggle = styled(DropdownToggle)`
  && {
    flex: 1;
    padding: 0;
    background-color: ${(props) => props.backgroundcolor};

    &:hover {
      background-color: rgba(0, 0, 0, ${(props) => props.hovercolor});
    }
  }
`;

SidebarDropDownNavItem.propTypes = {
  item: PropTypes.object,
  location: PropTypes.object
};

export default withRouter(SidebarDropDownNavItem);
